<template>
  <nav class="pnav" aria-label="Navigation principale">
    <div class="pnav-inner">
      <router-link to="/" class="pnav-logo" aria-label="Gestionnaire Citron, accueil">
        <img src="/img/logo_nav.png" alt="Citron Digital" width="293" height="40">
      </router-link>

      <ul class="pnav-links">
        <li><router-link to="/tarification">Tarif</router-link></li>
        <li><router-link to="/who">Informations</router-link></li>
        <li><router-link to="/assistance">Assistance</router-link></li>
      </ul>

      <div class="pnav-actions">
        <a class="pnav-site" :href="siteUrl">Site Citron Digital</a>
        <router-link to="/login" class="pub-btn pnav-login">Connexion</router-link>
        <router-link to="/register" class="pub-btn pub-btn--primary pnav-register">Créer mon compte</router-link>
      </div>
    </div>
  </nav>
</template>

<script>
  import {SITE_URL} from "@/components/public/siteLinks";

  /**
   * Barre du haut des pages hors connexion : la même barre bleu nuit que l'application, avec l'accès au site,
   * aux pages d'information et les deux actions utiles (connexion, création de compte).
   */
  export default {
    name: 'PublicNav',
    data() {
      return {
        siteUrl: SITE_URL,
      }
    }
  }
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/public.styl';

.pnav
  position fixed
  z-index 12
  top 0
  left 0
  right 0
  box-sizing border-box
  height PUB_NAV_HEIGHT
  background-color PUB_BAR
  // Le filet citron rappelle le site
  border-bottom 3px solid PUB_LEMON
  box-shadow 0 1px 5px rgba(37, 37, 37, 0.5)

.pnav-inner
  display flex
  align-items center
  justify-content space-between
  gap 16px
  box-sizing border-box
  height 100%
  max-width 1280px
  margin 0 auto
  padding 0 clamp(12px, 3vw, 28px)

.pnav-logo
  flex none
  display flex
  align-items center
  img
    display block
    height 28px
    width auto

.pnav-links
  display none
  flex 1
  margin 0
  padding 0 0 0 12px
  list-style none
  li
    display inline-block
    margin 0 0 0 4px
    padding 0
  a
    display inline-block
    padding 6px 12px
    color PUB_WHITE
    font-family PUB_FONT_TEXT
    font-size 0.97rem
    font-weight 600
    text-decoration none
    border-bottom 3px solid transparent
    &:hover
      border-bottom-color PUB_LEMON
    &.router-link-active
      border-bottom-color PUB_LEMON

.pnav-actions
  display flex
  align-items center
  gap 10px

.pnav-site
  display none
  padding 6px 4px
  color PUB_ON_BAR
  font-family PUB_FONT_TEXT
  font-size 0.9rem
  font-weight 600
  text-decoration underline
  text-decoration-color rgba(201, 210, 234, 0.5)
  text-underline-offset 0.2em
  &:hover
    color PUB_WHITE
    text-decoration-color PUB_LEMON

.pnav .pub-btn
  min-height 40px
  padding 0 16px
  font-size 0.95rem

// Sur la barre sombre, le bouton « contour » est blanc
.pnav-login
  background transparent
  border-color rgba(255, 255, 255, 0.85)
  color PUB_WHITE
  &:hover
    background PUB_WHITE
    color PUB_INK

.pnav .pnav-register
  border-color PUB_LEMON

// Téléphone : un seul bouton, citron
@media (max-width: 559px)
  .pnav-register
    display none
  .pnav .pnav-login
    background PUB_LEMON
    border-color PUB_LEMON
    color PUB_INK
    &:hover
      background PUB_LEMON_SOFT

@media (min-width: 560px)
  .pnav-logo img
    height 34px

@media (min-width: 800px)
  .pnav-site
    display inline-block

@media (min-width: 1000px)
  .pnav-links
    display block
  .pnav-logo img
    height 38px
</style>
